import { RefObject } from "react";

import { getFontClasses } from "@/app/common-utils/travelling-to-utils";
import TransformAnimation from "@/components/atoms/animation/transform-animation";
import ButtonGroup from "@/components/atoms/button-group/button-group";
import Loader from "@/components/atoms/loader/loader";
import withBrand from "@/components/with-brand";
import { Europe, Worldwide, WORLDWIDE_LOCATION } from "@/config/app-constant";
import { useStickyFooter } from "@/hooks/use-media-query/use-media-query-enhanced";
import {
  useTranslatedAnswersQTwoEurope,
  useTranslatedAnswersQTwoWorldwide,
  useFindTranslatedIdByEuropeValue,
  useFindTranslatedIdByWorldWideValue,
} from "@/utils/question-location-to.utils";
import { handleScrollToRef } from "@/utils/scrollUtils";

type EuropeAndWorldWideVisitSectionProps = {
  selectedAnswer: (id: number) => void;
  valueSelected: string | null;
  isDisable: boolean;
  quoteLoading: boolean | undefined;
  amtQuestionTwoText: string;
  amtQuestionTwoDescription: string;
  usagePage: string;
  headerRef: RefObject<HTMLHeadingElement | null>;
  actionButtonRef: RefObject<HTMLDivElement | null>;
  type?: string;
  brand?: "staysure" | "avanti";
};
function EuropeAndWorldWideVisitSection(
  props: Readonly<EuropeAndWorldWideVisitSectionProps>
) {
  const {
    selectedAnswer,
    valueSelected,
    isDisable,
    quoteLoading,
    amtQuestionTwoText,
    amtQuestionTwoDescription,
    usagePage,
    headerRef,
    actionButtonRef,
    brand,
    type,
  } = props;

  const isStickyFooter = useStickyFooter();

  // Use translated hooks
  const translatedEuropeAnswers = useTranslatedAnswersQTwoEurope();
  const translatedWorldwideAnswers = useTranslatedAnswersQTwoWorldwide();
  const europeSelectedAnswer = useFindTranslatedIdByEuropeValue(
    valueSelected ?? ""
  );
  const worldwideSelectedAnswer = useFindTranslatedIdByWorldWideValue(
    valueSelected ?? ""
  );

  const selectAnswerId =
    type === WORLDWIDE_LOCATION
      ? worldwideSelectedAnswer?.id
      : europeSelectedAnswer?.id;

  const travelOptionRelatedData = () => {
    if (type === WORLDWIDE_LOCATION) {
      return {
        answers: translatedWorldwideAnswers,
        location: Worldwide,
      };
    }
    return {
      answers: translatedEuropeAnswers,
      location: Europe,
    };
  };

  return (
    <TransformAnimation currentPage={usagePage}>
      <div className="md:mb-spacing-xxl md:mt-spacing-xxl mt-spacing-l">
        <h1
          className=" font-header-font lg:text-[39px] md:text-3xl text-[26px] lg:leading-[44.85px] 
            md:leading-[34.1px] leading-[29.9px] text-text-title md:text-left text-center"
          ref={headerRef}
        >
          {amtQuestionTwoText}
        </h1>
        <p
          className={` font-body-font md:text-[20px] mt-spacing-m mb-spacing-l text-[18px] 
            md:leading-[23px] leading-[20.7px]  md:text-left text-center ${getFontClasses(
              brand
            )}`}
        >
          {amtQuestionTwoDescription}
        </p>
        {quoteLoading ? (
          <Loader />
        ) : (
          <ButtonGroup
            setSelectedAnswer={selectedAnswer}
            selectedAnswer={selectAnswerId}
            answerArray={travelOptionRelatedData().answers}
            location={travelOptionRelatedData().location}
            type={type}
            isDisable={isDisable}
            onOptionClick={(id, dataTestId) => {
              const buttonElement = document.querySelector(`#${dataTestId}`);
              if (
                buttonElement?.classList.contains(
                  "componnt_lib_toggle_btn_inactive"
                )
              ) {
                handleScrollToRef(actionButtonRef, !isStickyFooter);
              }
            }}
          />
        )}
      </div>
    </TransformAnimation>
  );
}

export default withBrand(EuropeAndWorldWideVisitSection);
